'use strict';

var i18n = require('i18next');
var EditNat = require('actions/oneoneNat/EditNat');
var FormView = require('actions/oneoneNat/FormView');
var StaticView = require('actions/oneoneNat/StaticView');

/**
 * Action configuration for One to One NAT
 */
module.exports = {
  title: i18n.t('groups.oneoneNat'),
  Model: EditNat,
  FormView: FormView,
  TextView: StaticView,
};
